//@ts-nocheck
import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { firstLetterToUpperCase } from 'services/utils/string';

const StorageHistoryList = ({ items, loading }) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getTypeBadgeVariant = (type) => {
    switch (type) {
      case 'dodano':
        return 'success';
      case 'pobrano':
        return 'danger';
      case 'zmiana ręczna':
        return 'primary';
      default:
        return 'secondary';
    }
  };

  const getQuantityClass = (type) => {
    switch (type) {
      case 'dodano':
        return 'success';
      case 'pobrano':
        return 'danger';
      default:
        return 'muted';
    }
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border" role="status">
          <span className="sr-only">Ładowanie...</span>
        </div>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">Brak wpisów w historii magazynowej</p>
      </div>
    );
  }
  console.log(items);
  return (
    <Table responsive striped hover>
      <thead>
        <tr>
          <th>LP</th>
          <th>Data</th>
          <th>Typ</th>
          <th>Produkt</th>
          <th>Ilość</th>
          <th>Stan po operacji</th>
          <th>Opis</th>
          <th>Użytkownik</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <tr key={item._id}>
            <td>{index + 1}</td>
            <td>{formatDate(item.createdAt)}</td>
            <td>
              <Badge bg={getTypeBadgeVariant(item.type)}>
                {firstLetterToUpperCase(item.type)}
              </Badge>
            </td>
            <td>
              <strong>
                {item.storageItem?.name || 'Nieznany produkt'}
              </strong>
              {item.storageItem?.type && (
                <div>
                  <small className="text-muted">
                    {item.storageItem.type}
                  </small>
                </div>
              )}
            </td>
            <td className={`fw-bold text-${getQuantityClass(item.type)}`}>
              {item.type === 'dodano'
                ? '+'
                : item.type === 'pobrano'
                ? ''
                : ''}
              {item.quantity}
            </td>
            <td>
              <strong>{item.quantityAfter}</strong>
            </td>
            <td>
              <small>{item.description}</small>
            </td>
            <td>
              <small>{item.user || 'Nieznany użytkownik'}</small>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default StorageHistoryList;
